import { defer, type LoaderFunctionArgs } from "@shopify/remix-oxygen";
import { trimSlashes } from "~/utils";
import { loader as loaderPage, meta as metaPage } from "~/data/loaders/page";
import { MetaFunction } from "@remix-run/react";

export const getSlug = ({
  params,
}: {
  params: LoaderFunctionArgs["params"];
}) => {
  const { "*": pathname } = params;
  const path = trimSlashes([pathname].join("/"));
  const slug = path || "/";

  return slug;
};

export const meta: MetaFunction<typeof loader> = ({ data, ...rest }) => {
  const isRouteType = (type: string) => {
    return data?.routeType === type;
  };

  if (isRouteType("page")) {
    return metaPage({ data, ...rest });
  } else {
    return undefined;
  }
};

export async function loader({ request, params, ...rest }: LoaderFunctionArgs) {
  let loader;

  loader = loaderPage({ request, params, ...rest });

  return loader;
}
